(function (angular, app) {
    'use strict';

    var SPECIAL_TYPES = {
        REGULAR_SPECIALS: 'regular',
        LOYALTY_SPECIALS: 'loyalty'
    };

    var specialsData = {
        specials: [],
        filters: undefined,
        total: undefined
    };

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.specials', {
                url: '/specials?{filters:json}&{sort:json}',
                reloadOnSearch: false,
                data: {
                    name: 'specials'
                },
                metaTags: {
                    title: ['$filter', function ($filter) {
                        return ($filter('translate')('Specials'));
                    }]
                },
                views: {
                    '@': {
                        templateUrl: 'template/views/specials/index.html',
                        controller: 'SpecialsCtrl'
                    }
                }
            });
        }])
        .run(['$rootScope', function($rootScope) {
            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
                if (!toState.name.startsWith('app.specials') || toState.name === fromState.name) {
                    specialsData.specials = [];
                    specialsData.filters = specialsData.total = undefined;
                }
            });
        }])
        .controller('SpecialsCtrl', [
            '$scope', '$rootScope', '$q', '$state', '$stateParams', 'Api', 'Config', 'Util', 'Items', 'Cart', 'Specials', 'FilterManager', 'DataLayer', 'User', 'spSpecialTypeChecker',
            function ($scope, $rootScope, $q, $state, $stateParams, api, config, util, items, cart, specials, FilterManager, DataLayer, user, spSpecialTypeChecker) {
                var LOYALTY_SPECIAL_DRIVERS = {},
                    specialsESFilters = {
                    must: {
                        lessThan: {
                            startDate: new Date()
                        },
                        greaterThan: {
                            endDate: new Date()
                        },
                        term: {
                            displayOnWeb: true
                        }
                    }
                };
                if (!config.retailer.settings.showCouponsSpecials) {
                    specialsESFilters.must.term.isCoupon = false;
                }
                $rootScope.spMixPanel.trackProperties({
                    source: $rootScope.SP_SERVICES.SOURCES.SPECIALS
                });
                $scope.total = specialsData.total || 0;
                $scope.specials = specialsData.specials;
                util.setCurrentCategory({id: 'specials'}, $scope);

                function _addChunkToSpecials(isInit) {
                    var totalItems = items.getItemsLength();
                    if (!isInit && totalItems == $scope.total) return;

                    return items.getChunkAmount().then(function(size) {
                        var params = {
                            from: totalItems,
                            size: size,
                            filters: angular.copy(specialsESFilters),
                            sort: [{priority:"desc"}, {sort: 'asc'}, {id:"desc"}]
                        };

                        FilterManager.parseFilters(params, [$scope.productTagsFilter, $scope.brandFilter, $scope.categoriesFilter, $scope.specialsTypeFilter]);

                        return items.getItems({
                            url: '/v2/retailers/:rid/branches/:bid/specials',
                            params: params
                        });
                    }).then(function (specials) {
                        $scope.total = specials.total;
                        if(config.retailer.settings.enablePersonalReplacement) {
                                angular.forEach(specials.specials, function(special) {
                                    if(special && special.item && special.item.branch && special.item.branch.isOutOfStock) {
                                        user.getReplacementSuggestions([special.item.id], []).then(function(data) {
                                        if (data.length > 0 && data[0].suggestions) {
                                            special.showReplacementLabel = true;
                                            special._suggestions = data[0].suggestions;
                                        }
                                    })
                                }
                                return special; 
                            });
                        }
                        util.pushAll($scope.specials, setSpecialsItem(specials.specials));
                        util.setProductIndexPosition(specials.specials);
                        DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: specials.specials, data: {productsStartingPosition: specials.total}});
                    });
                }

                function onChange() {
                    FilterManager.setFiltersToUrl({
                        productTag: $scope.productTagsFilter,
                        category: $scope.categoriesFilter,
                        brand: $scope.brandFilter,
                        type: $scope.specialsTypeFilter
                    });

                    items.resetItems();
                    return _addChunkToSpecials(true);
                }

                function parseSpecialTypeFilter(params) {
                    var filterValues = this.value;
                    if (!filterValues || !filterValues.length) {
                        return;
                    }

                    var isMissing = false,
                        isExists = false,
                        loyaltyClubIds = [];
                    angular.forEach(filterValues, function(valItem) {
                        if (valItem.value === SPECIAL_TYPES.REGULAR_SPECIALS) {
                            isMissing = true;
                        } else if (!!LOYALTY_SPECIAL_DRIVERS[valItem.value]) {
                            isExists = true;
                            Array.prototype.push.apply(loyaltyClubIds, LOYALTY_SPECIAL_DRIVERS[valItem.value]);
                        }
                    });
                    if (isMissing !== isExists) {
                        params.filters = params.filters || {};
                        params.filters.must = params.filters.must || {};
                        params.filters.must[isExists ? 'exists' : 'missing'] = ['loyaltyClubsIds'];
                    }

                    if (loyaltyClubIds.length) {
                        params.filters.must = params.filters.must || {};
                        params.filters.must.term = params.filters.must.term || {};
                        params.filters.must.term.loyaltyClubsIds = loyaltyClubIds;
                    }
                }

                $scope.productTagsFilter = FilterManager.getProductTagsFilter(onChange, $scope, true);
                $scope.brandFilter = FilterManager.getBrandsFilter(onChange, 'branch.productsData.brands.id');
                $scope.categoriesFilter = FilterManager.getCategoriesFilter(onChange, 'branch.productsData.categories.id');
                var specialTypeItems = [{
                    value: SPECIAL_TYPES.REGULAR_SPECIALS,
                    name: {
                        1: 'מבצעי הרשת',
                        2: 'Specials',
                        3: 'ofertas',
                        4: 'Акции сети',
                        5: 'Promotions',
                        6: 'العروض الخاصة',
                    }
                }];


                if ($rootScope.config.retailer.loyaltyClubDrivers) {
                    angular.forEach($rootScope.config.retailer.loyaltyClubDrivers || [], function (driver) {
                        if (driver.loyaltyClubIds && driver.loyaltyClubIds.length) {
                            LOYALTY_SPECIAL_DRIVERS[driver.id] = driver.loyaltyClubIds;
                            specialTypeItems.push({
                                value: driver.id,
                                name: {
                                    1: 'מבצעי ' + driver.name,
                                    2: driver.name + ' Specials',
                                    3: 'Promociones de ' + driver.name,
                                    4: 'Акции ' + driver.name,
                                    5: 'Promos Club',
                                    6: 'الصفقات الخاصة للنادي',
                                }
                            })
                        }
                    });
                }
                $scope.specialsTypeFilter = new FilterManager.SPFrontendViewFilter({
                    notFinished: false,
                    title: 'Special type',
                    options: {
                        items: specialTypeItems,
                        orderBy: '-value'

                    },
                    onChange: onChange,
                    parse: parseSpecialTypeFilter
                });

                $scope.spItemsFilters = [$scope.productTagsFilter, $scope.categoriesFilter, $scope.brandFilter];

                if (!!config.retailer.loyaltyClubDrivers &&
                    !!config.retailer.loyaltyClubDrivers.find(function (driver) { return driver.isActive; })) {
                    $scope.spItemsFilters.splice(0, 0, $scope.specialsTypeFilter);
                }

                function setSpecialsItem(specials) {
                    angular.forEach(specials, function (special) {
                        if (!special.item) return;

                        //#region re-order list special
                        /**
                         * Because sp-promotion currently always take the first special in specials list to display
                         * So in case we have many specials on the same product, we need to re-order the specials to display correct special on UI
                         */

                        var itemProduct = special.item;
                        var itemBranchProduct = special.isCase ? itemProduct.branch.case : itemProduct.branch;
                        if(itemBranchProduct.specials.length > 1) {
                            itemBranchProduct.specials = _moveMainSpeciasToTop(special, itemBranchProduct.specials);
                        }
                        //#endregion re-order list special
                        
                        special.item = cart.getProduct(itemProduct);
                    });

                    return specials;
                }

                function _moveMainSpeciasToTop(mainSpecial, specials) {
                    var clonedSpecials = angular.copy(specials);
                    var mainSpecialIndex = clonedSpecials.findIndex(function(item) { return item.id === mainSpecial.id; } );

                    if (mainSpecialIndex > 0) {
                        var itemArray = clonedSpecials.splice(mainSpecialIndex, 1);
                        var item = itemArray[0];
                        clonedSpecials.unshift(item);
                    }

                    return clonedSpecials;
                }

                util.currentScopeListener($scope, $rootScope.$on('cart.lines.add', function () {
                    setSpecialsItem(specialsData.specials);
                }));

                function getNextProduct(index, toAdd) {
                    var product, next, nextTwo, selectedIndex;
                    for (var i = index + toAdd; i < items.items.length && i >= 0; i += toAdd) {
                        if (items.items[i].item) {
                            if (!product) {
                                product = items.items[i].item;
                                selectedIndex = i;
                            } else if (!next) {
                                next = items.items[i].item;
                            } else if (!nextTwo) {
                                nextTwo = items.items[i].item;
                            } else {
                                break;
                            }
                        }
                    }
                    var siblings = [];
                    if (next) {
                        siblings.push(next);
                    }
                    if (nextTwo) {
                        siblings.push(nextTwo);
                    }
                    return {
                        total: $scope.total,
                        index: selectedIndex,
                        product: product,
                        siblings: siblings
                    };
                }

                var newChunkPromise;

                function nextProduct(index) {
                    index = !angular.isUndefined(index) ? index : $scope.total;
                    var productData = getNextProduct(index, 1);
                    if (productData.product || productData.index >= productData.total) {
                        var defer = $q.defer();
                        defer.resolve(productData);
                        return defer.promise;
                    } else {
                        if (newChunkPromise) {
                            return newChunkPromise;
                        }

                        var prom = _addChunkToSpecials();
                        if (prom) {
                            return newChunkPromise = prom.then(function () {
                                newChunkPromise = null;
                                return nextProduct(index);
                            });
                        }
                    }
                }

                function previousProduct(index) {
                    index = !angular.isUndefined(index) ? index : 0;
                    var defer = $q.defer();
                    defer.resolve(getNextProduct(index, -1));
                    return defer.promise;
                }

                $scope.openSpecial = function (special, index) {
                    // Emit ECOM-17469 Special Selected event
                    var mixpanelProperties = {};
                    mixpanelProperties[$rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_SPECIAL_SELECTED] = {
                        promotionId: special.id,
                        promotionType: spSpecialTypeChecker.getSpecialType(special) || $rootScope.SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                        source: $rootScope.SP_SERVICES.SOURCES.SPECIALS,
                        specialPosition: index !== undefined ? $rootScope.SP_SERVICES.SOURCES.SPECIAL_LIST + ' ' + (index + 1).toString() : $rootScope.SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                        productImageUrl: special.frontendImageUrl
                    };
                    $rootScope.spMixPanel.trackPreviousProperties(mixpanelProperties);

                    // TODO: CLICK_SAVE_SELECTED event should be implemented when click & save functionality is identified
                    // This would typically be in a product click handler or special offer click handler
                    // Example implementation:
                    // $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_CLICK_SAVE_SELECTED, {
                    //     productId: special.item ? special.item.id : null,
                    //     savingsAmount: special.savings || 0,
                    //     selectionMethod: 'Special Offer Click'
                    // });

                    if (util.isSingleItemSpecial(special)) {
                        var siblings = [];
                        util.pushAll(siblings, getNextProduct(index, 1).siblings);
                        util.pushAll(siblings, getNextProduct(index, -1).siblings);
                        special.item.isCaseMode = special.isCase; // if isCase from special page = true, we need to set it to item in details page
                        return util.openProduct(special.item, {
                            next: nextProduct,
                            previous: previousProduct,
                            siblings: siblings,
                            total: $scope.total,
                            index: index,
                            source: $rootScope.SP_SERVICES.SOURCES.SPECIALS
                        });
                    }
                    if($rootScope.config.retailer.settings.isNewPromotionDesignEnabled === 'true') {
                        util.showSpecialDetailsDialog(special.id);
                    } else {
                        $state.go('app.specials.special', {sid: special.id});
                    }
                };

                util.currentScopeListener($scope, $rootScope.$on('items.initiated', function () {
                    if ($scope.specials.length) {
                        return;
                    }

                    _addChunkToSpecials(true);
                }));

                util.currentScopeListener($scope, $rootScope.$on('document.scroll.end', function (data, event) {
                    event.start();
                    var promise = _addChunkToSpecials();
                    if (promise) {
                        promise.finally(function () {
                            event.done();
                        });
                    } else {
                        event.done();
                    }
                }));
                util.currentScopeListener($scope, $rootScope.$on('items.add', _addChunkToSpecials));

                FilterManager.setFiltersFromUrl({
                    productTag: $scope.productTagsFilter,
                    category: $scope.categoriesFilter,
                    brand: $scope.brandFilter,
                    type: $scope.specialsTypeFilter
                }, $stateParams.filters);

                $q.resolve().then(function() {
                    if (specialsData.filters) {
                        return specialsData.filters;
                    }

                    return specials.getFilters();
                }).then(function (results) {
                    specialsData.filters = results;


                    FilterManager.addProductTagsFilterOptions($scope.productTagsFilter, results.productTags);
                    FilterManager.addBrandsFilterOptions($scope.brandFilter, results.brands);
                    FilterManager.addCategoriesFilterOptions($scope.categoriesFilter, results.categories);
                }).finally(function () {
                    FilterManager.markFiltersAsFinished([$scope.productTagsFilter, $scope.brandFilter, $scope.categoriesFilter]);
                });
            }])

        //those controllers should move to their template
        .controller('PrutahTemplateSpecialsCtrl', ['$rootScope', 'Items', function($rootScope, Items) {
            Items.initPage($rootScope.config.retailer.settings.isNewPromotionDesignEnabled === 'true' ? {} : {
                defaultWidth: $rootScope.windowSize.width <= 768 ? 260 : 310
            });
        }])
        .controller('KikarTemplateSpecialsCtrl', ['Items', function(Items) {
            Items.initPage({
                defaultWidth: 235 // 235
            });
        }]);

})(angular, app);
